module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"report-form-dialog\" class=\"select-field-dialog\" title=\"Select a")
    ; __append(escapeFn( (sectionTitle === 'App' ? 'n ' : ' ') + sectionTitle ))
    ; __append("\" style=\"display: none;\">\r\n\r\n    <div class=\"col-md-12 nopadding\" style=\"height:100%\">\r\n        <div class=\"pre-scrollable db-panel\" style=\"height: 100%;\">\r\n            <div id=\"dbPanelOne\"></div>\r\n            <div id=\"dbPanelTwo\"></div>\r\n        </div>\r\n    </div>\r\n\r\n</div>")
  }
  return __output;

}